import kotfmThumbnail from './data/media/kotfm-thumbnail.jpg';
import miThumbnail from './data/media/mi-thumbnail.jpg';
import napoleonThumbnail from './data/media/napoleon-thumbnail.jpg';
import oppenheimerThumbnail from './data/media/oppenheimer-thumbnail.jpg';
import wonkaThumbnail from './data/media/wonka-thumbnail.jpg';

import koftmTrailer from './data/media/kotfm-trailer.mp4';
import miTrailer from './data/media/mi-trailer.mp4';
import napoleonTrailer from './data/media/napoleon-trailer.mp4';
import oppenheimerTrailer from './data/media/oppenheimer-trailer.mp4';
import wonkaTrailer from './data/media/wonka-trailer.mp4';


const sources = [
    { imageSource: kotfmThumbnail, videoSource: koftmTrailer },
    { imageSource: miThumbnail, videoSource: miTrailer },
    { imageSource: napoleonThumbnail, videoSource: napoleonTrailer },
    { imageSource: oppenheimerThumbnail, videoSource: oppenheimerTrailer },
    { imageSource: wonkaThumbnail, videoSource: wonkaTrailer },
];

export default sources;